import { action } from 'typesafe-actions'
import { MarketingActionTypes } from './types'
import { IMarketing } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(MarketingActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: IMarketing[]) => action(MarketingActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(MarketingActionTypes.LIST_ERROR, errors)
export const listClear = () => action(MarketingActionTypes.LIST_CLEAR)

// Select Data
export const selectData = (id: string) => action(MarketingActionTypes.SELECT, id)
export const selectedData = () => action(MarketingActionTypes.SELECTED)
export const selectedClear = () => action(MarketingActionTypes.CLEAR_SELECTED)

// Create
export const createRequest = (doc: IMarketing) => action(MarketingActionTypes.CREATE_REQUEST, doc)
export const createSuccess = (doc: IMarketing) => action(MarketingActionTypes.CREATE_SUCCESS, doc) // Newly created data
export const createError = (errors: any) => action(MarketingActionTypes.CREATE_ERROR, errors)

// // Read
// export const readRequest = (data: IMarketing) => action(MarketingActionTypes.READ_REQUEST, data)
// export const readSuccess = (data: IMarketing) => action(MarketingActionTypes.READ_SUCCESS, data)
// export const readError = (message: string) => action(MarketingActionTypes.READ_ERROR, message)

// Update
export const updateRequest = (keyValues: any) => action(MarketingActionTypes.UPDATE_REQUEST, keyValues)
export const updateSuccess = (doc: IMarketing) => action(MarketingActionTypes.UPDATE_SUCCESS, doc) // Updated Data
export const updateError = (errors: any) => action(MarketingActionTypes.UPDATE_ERROR, errors)

// Delete
export const deleteRequest = (doc: IMarketing) => action(MarketingActionTypes.DELETE_REQUEST, doc)
export const deleteSuccess = (id: string) => action(MarketingActionTypes.DELETE_SUCCESS, id)  // Return deleted organiser id to remove from state
export const deleteError = (errors: any) => action(MarketingActionTypes.DELETE_ERROR, errors)
